import { render, staticRenderFns } from "./cmpetiquetasvolumespedido.vue?vue&type=template&id=29116ecc&"
import script from "./cmpetiquetasvolumespedido.vue?vue&type=script&lang=js&"
export * from "./cmpetiquetasvolumespedido.vue?vue&type=script&lang=js&"
import style0 from "./cmpetiquetasvolumespedido.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports